import { AuthRole, AuthUser } from './types';

type AuthResponse = {
  user: AuthUser;
};

const assertJson = async <T,>(response: Response): Promise<T> => {
  const payload = await response.json().catch(() => null);

  if (!response.ok) {
    const message =
      payload && typeof payload === 'object' && 'error' in payload
        ? String(payload.error)
        : 'Request failed.';
    throw new Error(message);
  }

  return payload as T;
};

export const fetchSession = async (): Promise<AuthUser | null> => {
  const response = await fetch('/api/auth/session', {
    credentials: 'include',
  });

  if (response.status === 401) {
    return null;
  }

  const payload = await assertJson<AuthResponse>(response);
  return payload.user;
};

export const signInWithGoogle = async (
  credential: string,
  role: AuthRole,
): Promise<AuthUser> => {
  const response = await fetch('/api/auth/google', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ credential, role }),
  });

  const payload = await assertJson<AuthResponse>(response);
  return payload.user;
};

export const signOut = async (): Promise<void> => {
  const response = await fetch('/api/auth/logout', {
    method: 'POST',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Unable to sign out.');
  }
};

